import React, { useContext, useState } from "react";
import Context from "../../Context";
import "../../../../node_modules/react-perfect-scrollbar/dist/css/styles.css";
import PerfectScrollbar from "react-perfect-scrollbar";
import {
  Link,
  Route,
  useRouteMatch,
  useLocation,
  matchPath,
} from "react-router-dom";
import SVGShip1 from "../Misc/SvgIcons/SVGShip1";
import SVGManual from "../Misc/SvgIcons/SVGManual";
import SVGGroup1 from "../Misc/SvgIcons/SVGGroup1";

function Aside(props) {
  const cx = useContext(Context);
  const inAdmin = props.inAdmin;

  const referenceClasses = [
    "structure",
    "staff",
    "position",
    "calendar",
    "library",
    "emergency_folder",
    "vendor",
    "category",
    "model",
    "maintenance",
  ];
  let showReferenceButton = false;
  referenceClasses.forEach((essence) => {
    let access = cx.user.classAccess[essence] || {};
    if (access.c || access.u || access.d) {
      showReferenceButton = true;
    }
  });

  return (
    <div
      onMouseEnter={cx.asideMouseEnter}
      onMouseLeave={cx.asideMouseLeave}
      className={`aside aside-left  aside-fixed  d-flex flex-column flex-row-auto ${
        cx.asideIsOn ? "aside-on" : ""
      }`}
    >
      <div className="brand flex-column-auto">
        <a href="/" className="brand-logo">
          <span
            className={`text-${
              inAdmin ? "warning" : "light"
            } text-uppercase font-size-h3 font-weight-boldest`}
          >
            <span className="text-muted">Ship</span>
            {inAdmin ? "Admin" : "Safety"}
          </span>
        </a>
        <button
          onClick={cx.asideToggle}
          className="brand-toggle btn btn-sm px-0"
        >
          <span className="svg-icon svg-icon svg-icon-xl">
            <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
              <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <polygon points="0 0 24 0 24 24 0 24" />
                <path
                  d="M5.29288961,6.70710318 C4.90236532,6.31657888 4.90236532,5.68341391 5.29288961,5.29288961 C5.68341391,4.90236532 6.31657888,4.90236532 6.70710318,5.29288961 L12.7071032,11.2928896 C13.0856821,11.6714686 13.0989277,12.281055 12.7371505,12.675721 L7.23715054,18.675721 C6.86395813,19.08284 6.23139076,19.1103429 5.82427177,18.7371505 C5.41715278,18.3639581 5.38964985,17.7313908 5.76284226,17.3242718 L10.6158586,12.0300721 L5.29288961,6.70710318 Z"
                  fill="#000000"
                  fillRule="nonzero"
                  transform="translate(8.999997, 11.999999) scale(-1, 1) translate(-8.999997, -11.999999) "
                />
                <path
                  d="M10.7071009,15.7071068 C10.3165766,16.0976311 9.68341162,16.0976311 9.29288733,15.7071068 C8.90236304,15.3165825 8.90236304,14.6834175 9.29288733,14.2928932 L15.2928873,8.29289322 C15.6714663,7.91431428 16.2810527,7.90106866 16.6757187,8.26284586 L22.6757187,13.7628459 C23.0828377,14.1360383 23.1103407,14.7686056 22.7371482,15.1757246 C22.3639558,15.5828436 21.7313885,15.6103465 21.3242695,15.2371541 L16.0300699,10.3841378 L10.7071009,15.7071068 Z"
                  fill="#000000"
                  fillRule="nonzero"
                  opacity="0.3"
                  transform="translate(15.999997, 11.999999) scale(-1, 1) rotate(-270.000000) translate(-15.999997, -11.999999) "
                />
              </g>
            </svg>
          </span>
        </button>
      </div>
      <div className="aside-menu-wrapper flex-column-fluid">
        <div
          id="kt_aside_menu"
          className="aside-menu my-4 "
          data-menu-vertical="1"
          data-menu-scroll="1"
          data-menu-dropdown-timeout="500"
        >
          <PerfectScrollbar>
            <ul className="menu-nav">
              {inAdmin ? (
                <Route path="/admin">
                  <AsideLink title="Подразделения" to="/admin/areas">
                    <i className="fa fa-sitemap menu-icon"></i>
                  </AsideLink>
                  <AsideLink title="Группы" to="/admin/groups">
                    <i className="flaticon2-group menu-icon"></i>
                  </AsideLink>
                  <AsideLink title="Пользователи" to="/admin/users">
                    <i className="fa fa-address-book-o menu-icon"></i>
                  </AsideLink>
                  <hr />
                  <AsideLink title="Документооборот" to="/admin/workflow">
                    <i className="flaticon2-browser-2 menu-icon"></i>
                  </AsideLink>
                  <hr />
                  <AsideLink title="Журнал API" to="/admin/apiLog">
                    <i className="flaticon2-cardiogram menu-icon"></i>
                  </AsideLink>
                  <AsideLink title="Журнал событий" to="/admin/eventLog">
                    <i className="flaticon2-rectangular menu-icon"></i>
                  </AsideLink>
                  <AsideLink title="Реестр" to="/admin/registry">
                    <i className="flaticon2-layers menu-icon"></i>
                  </AsideLink>
                  <AsideLink title="Консоль API" to="/admin/apiConsole">
                    <i className="fa fa-plug menu-icon"></i>
                  </AsideLink>
                </Route>
              ) : null}
              {!inAdmin ? (
                <Route path="/">
                  {cx.user.getClassAccess("manual") === true ||
                  cx.user.getClassAccess("library") === true ? (
                    <AsideGroup
                      title="Документы"
                      icon={
                        <span className="svg-icon  menu-icon    ">
                          <SVGManual />
                        </span>
                      }
                      routeMatches={[
                        "/manual",
                        "/library",
                        "/workdoc",
                        "/emergency_folder",
                        "/certificate",
                        "/manualchanged",
                      ]}
                    >
                      {cx.user.getClassAccess("manual") === true ? (
                        <AsideLink title="Руководства" to="/manual/">
                          <i className="menu-bullet menu-bullet-dot">
                            <span></span>
                          </i>
                        </AsideLink>
                      ) : null}
                      {cx.user.getClassAccess("manual") === true ? (
                        <AsideLink title="Рабочая документация" to="/workdoc/">
                          <i className="menu-bullet menu-bullet-dot">
                            <span></span>
                          </i>
                        </AsideLink>
                      ) : null}
                      {cx.user.getClassAccess("certificate") === true ? (
                        <AsideLink title="Судовые документы" to="/certificate/">
                          <i className="menu-bullet menu-bullet-dot">
                            <span></span>
                          </i>
                        </AsideLink>
                      ) : null}
                      {cx.user.getClassAccess("library") === true ? (
                        <AsideLink title="Библиотека" to="/library/">
                          <i className="menu-bullet menu-bullet-dot">
                            <span></span>
                          </i>
                        </AsideLink>
                      ) : null}
                      {cx.user.getClassAccess("emergency_folder") === true ? (
                        <AsideLink
                          title="Аварийная папка"
                          to="/emergency_folder/"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span></span>
                          </i>
                        </AsideLink>
                      ) : null}
                      {cx.user.getClassAccess("manual") === true ? (
                        <AsideLink title="Изменения" to="/manualchanged/">
                          <i className="menu-bullet menu-bullet-dot">
                            <span></span>
                          </i>
                        </AsideLink>
                      ) : null}
                    </AsideGroup>
                  ) : null}

                  {cx.user.getClassAccess("element") === true ||
                  cx.user.getClassAccess("element") === true ? (
                    <AsideGroup
                      title="Технический раздел"
                      icon={
                        <i className="svg-icon menu-icon">
                          <SVGShip1 />
                        </i>
                      }
                      routeMatches={["/element"]}
                    >
                      {cx.user.getClassAccess("element") === true ? (
                        <AsideLink title="Структура СТСиК" to="/element/">
                          <i className="menu-bullet menu-bullet-dot">
                            <span></span>
                          </i>
                        </AsideLink>
                      ) : null}
                      {cx.user.getClassAccess("maintenance") === true ? (
                        <AsideLink title="Конструктор ТО" to="/maint/">
                          <i className="menu-bullet menu-bullet-dot">
                            <span></span>
                          </i>
                        </AsideLink>
                      ) : null}
                      {cx.user.getClassAccess("product") === true ? (
                        <AsideLink title="Складские запасы" to="/product/">
                          <i className="menu-bullet menu-bullet-dot">
                            <span></span>
                          </i>
                        </AsideLink>
                      ) : null}
                      {cx.user.getClassAccess("techdoc") === true ? (
                        <AsideLink title="Документация" to="/techdoc/">
                          <i className="menu-bullet menu-bullet-dot">
                            <span></span>
                          </i>
                        </AsideLink>
                      ) : null}

                      {cx.user.getClassAccess("cistern") === true ? (
                        <AsideLink title="Судовой бункер" to="/bunker/">
                          <i className="menu-bullet menu-bullet-dot">
                            <span></span>
                          </i>
                        </AsideLink>
                      ) : null}
                      {cx.user.getClassAccess("tracker") === true ? (
                        <AsideLink title="Операции" to="/tracker/">
                          <i className="menu-bullet menu-bullet-dot">
                            <span></span>
                          </i>
                        </AsideLink>
                      ) : null}
                    </AsideGroup>
                  ) : null}
                  {cx.user.getClassAccess("crew") === true ||
                  cx.user.getClassAccess("crew") === true ? (
                    <AsideGroup
                      title="Персонал"
                      icon={
                        <i className="svg-icon menu-icon">
                          <SVGGroup1 />
                        </i>
                      }
                      routeMatches={["/crew"]}
                    >
                      {cx.user.getClassAccess("crew") === true ? (
                        <AsideLink title="Экипаж" to="/crew/">
                          <i className="menu-bullet menu-bullet-dot">
                            <span></span>
                          </i>
                        </AsideLink>
                      ) : null}
                    </AsideGroup>
                  ) : null}
                  {cx.user.getClassAccess("report") === true ? (
                    <AsideLink title="Отчеты" to="/report">
                      <span className="svg-icon menu-icon">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="#000000"
                        >
                          <g fill="#000000">
                            <path
                              opacity="0.3"
                              d="M19 22H5C4.4 22 4 21.6 4 21V3C4 2.4 4.4 2 5 2H14L20 8V21C20 21.6 19.6 22 19 22ZM15 17C15 16.4 14.6 16 14 16H8C7.4 16 7 16.4 7 17C7 17.6 7.4 18 8 18H14C14.6 18 15 17.6 15 17ZM17 12C17 11.4 16.6 11 16 11H8C7.4 11 7 11.4 7 12C7 12.6 7.4 13 8 13H16C16.6 13 17 12.6 17 12ZM17 7C17 6.4 16.6 6 16 6H8C7.4 6 7 6.4 7 7C7 7.6 7.4 8 8 8H16C16.6 8 17 7.6 17 7Z"
                              fill="#000000"
                            />
                            <path
                              d="M15 8H20L14 2V7C14 7.6 14.4 8 15 8Z"
                              fill="#000000"
                            />
                          </g>
                        </svg>
                      </span>
                    </AsideLink>
                  ) : null}
                  <hr />
                  {showReferenceButton && (
                    <AsideLink title="Параметры" to="/reference/">
                      <i className="fa fa-cogs menu-icon"></i>
                    </AsideLink>
                  )}
                </Route>
              ) : null}
            </ul>
          </PerfectScrollbar>
        </div>
      </div>
      {cx.asideIsOn ? (
        <div
          onClick={() => cx.asideToggleOnOff(false)}
          className="aside-overlay"
        ></div>
      ) : null}
    </div>
  );
}

function AsideGroup(props) {
  let [open, toggle] = useState(0);
  const location = useLocation();
  let active = false;
  props.routeMatches.forEach((path) => {
    let match = matchPath(location.pathname, {
      path,
    });
    if (match) {
      active = true;
      // open = true;
    }
  });
  return (
    <li
      className={`menu-item menu-item-submenu ${
        active ? "menu-item-active" : ""
      } ${open ? "menu-item-open" : ""}`}
      aria-haspopup="true"
      data-menu-toggle="hover"
      onClick={() => toggle(!open)}
    >
      <div className="menu-link menu-toggle">
        {props.icon}
        <span className="menu-text">{props.title}</span>
      </div>
      <div className="menu-submenu">
        <ul className="menu-subnav">{props.children}</ul>
      </div>
    </li>
  );
}

function AsideLink(props) {
  const cx = useContext(Context);
  const isOpen = useRouteMatch(props.to);
  return (
    <li
      className={`menu-item ${isOpen ? "menu-item-active" : ""}`}
      aria-haspopup="true"
      data-menu-toggle="hover"
    >
      <Link
        to={props.to}
        onClick={(e) => {
          e.stopPropagation();
          cx.asideToggleOnOff(false);
        }}
        className="menu-link"
      >
        {props.children}
        <span className="menu-text">{props.title}</span>
      </Link>
    </li>
  );
}
export default Aside;
